module.exports = "/_next/static/images/tv-left-db946fd220715207b1758183d9a8f406.png";